var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunctionalTraining(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 12.6667H101.333C113.276 12.6667 119.247 12.6667 122.957 16.3768C126.667 20.0867 126.667 26.0578 126.667 38.0001V76.0001C126.667 87.9422 126.667 93.9133 122.957 97.6233C119.247 101.333 113.276 101.333 101.333 101.333H57.0001",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 12.6667H101.333C113.276 12.6667 119.247 12.6667 122.957 16.3768C126.667 20.0867 126.667 26.0578 126.667 38.0001V76.0001C126.667 87.9422 126.667 93.9133 122.957 97.6233C119.247 101.333 113.276 101.333 101.333 101.333H57.0001",
    stroke: "url(#paint0_linear_16725_948)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3333 41.1667H101.333",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3333 41.1667H101.333",
    stroke: "url(#paint1_linear_16725_948)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 107.667V82.3334C12.6667 76.3623 12.6667 73.3768 14.5217 71.5218C16.3768 69.6667 19.3623 69.6667 25.3334 69.6667H38.0001M12.6667 107.667H38.0001M12.6667 107.667V139.333M38.0001 69.6667V107.667M38.0001 69.6667H57.0001H76.0001M38.0001 107.667V139.333",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 107.667V82.3334C12.6667 76.3623 12.6667 73.3768 14.5217 71.5218C16.3768 69.6667 19.3623 69.6667 25.3334 69.6667H38.0001M12.6667 107.667H38.0001M12.6667 107.667V139.333M38.0001 69.6667V107.667M38.0001 69.6667H57.0001H76.0001M38.0001 107.667V139.333",
    stroke: "url(#paint2_linear_16725_948)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 41.1667C38.0001 48.1623 32.329 53.8333 25.3334 53.8333C18.3378 53.8333 12.6667 48.1623 12.6667 41.1667C12.6667 34.1711 18.3378 28.5 25.3334 28.5C32.329 28.5 38.0001 34.1711 38.0001 41.1667Z",
    stroke: "white",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 41.1667C38.0001 48.1623 32.329 53.8333 25.3334 53.8333C18.3378 53.8333 12.6667 48.1623 12.6667 41.1667C12.6667 34.1711 18.3378 28.5 25.3334 28.5C32.329 28.5 38.0001 34.1711 38.0001 41.1667Z",
    stroke: "url(#paint3_linear_16725_948)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_948",
    x1: 12.6667,
    y1: 12.6667,
    x2: 141.817,
    y2: 59.9571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_948",
    x1: 63.3333,
    y1: 41.1667,
    x2: 63.7466,
    y2: 45.6399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_948",
    x1: 12.6667,
    y1: 69.6667,
    x2: 88.9254,
    y2: 89.4104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_948",
    x1: 12.6667,
    y1: 28.5,
    x2: 42.773,
    y2: 37.0741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionalTraining);
export default __webpack_public_path__ + "static/media/functional-training.6e78f0b2b2371e2b883d897de7a0d086.svg";
export { ForwardRef as ReactComponent };